import React from 'react';

import Framework from "@beardeddevops/react.framework"
import Collections from "../../../../../components/Collections";

const breadcrumbsStatic = [
	{
		name: 'Financials',
		url: '/financial',
		icon: 'dashboard'
	},
	{
		name: 'FE Weekly Audit',
		url: '/financial/fe_weekly_audit',
		icon: 'book',
	}
];

class FieldEngineerWeeklyAudit extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history} />
				<Collections.FieldEngineerWeeklyAudit />
			</div>
		);
	}
}

export default Framework.Components.withRootState(FieldEngineerWeeklyAudit);
